import React, { useEffect, useRef, useState } from "react";
import withLayout from "../../hocs/Layout";
import { filterByProp, findInObjArr } from "../../helpers/UtilityHelper";
import {
    apiConstants,
    post,
    get,
    postMultipart,
    getDownload,
    //   getDownload,
} from "../../common/constants";
import "./location.css";
import AddLocation from "./addLocation";
import LocationDataGrid from "./LocationDataGrid";
import Loader from "../../common/Loader";
import {
    Alert,
    Button,
    ButtonGroup,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useSnackbar } from "notistack";
import {
    AddCircleRounded,
    DownloadRounded,
    UploadFileRounded,
} from "@mui/icons-material";
import { MerchantFilterCached } from "../../common/ProshipFormComponents";
import { useForm } from "react-hook-form";
import PageTitle from "../PageTitle";
import { FilterLocation } from "./Filter";
import SideDrawer from "../SideDrawer";
import { FormProvider } from "../../common/hook-form";


export function MerchantLocations() {
    const [show, setShow] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [locationList, setLocation] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentId, setCurrentId] = useState();
    const [page, setPage] = useState(0);
    const [open, setOpen] = useState(false);
    const [merchant, setMerchant] = useState();
    const [sizePerPage, setSizePerPage] = useState(10);
    const [filteredLocationList, setFilteredLocationList] = useState([]);
    const [isDelete, setIsDelete] = useState(false)
    const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
    const [activeTab, setActiveTab] = useState('B2B');
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [failedOrders, setFailedOrders] = useState([]);
    const [uploadResponse, setUploadResponse] = useState(null);


    const bulkUploadRef = useRef();
    const { enqueueSnackbar } = useSnackbar();

    const existingLocationNames = filteredLocationList?.map(location => location.name?.toLowerCase().trim());

    const methods = useForm({
        defaultValues: {
            merchant: '',
        }
    });
    const { reset, watch } = methods


    const handleClose = () => {
        setShow(false);
    };

    const handleShow = () => {
        if (merchant) {
            setShow(true)
        } else {
            enqueueSnackbar("Please select a Merchant!", { variant: "error" });
        }
    };

    const addPickupLocation = (param) => {
        setFormLoading(true);
        const addressCopy = Object.assign(
            {},
            { status: "ACTIVE", address_type: "PICKUP", country: "India" },
            currentId,
            param,
            {
                shipmentType: activeTab === 'B2B' ? 'B2B' : 'B2C',
            }
        );
        post(
            `${apiConstants.PICKUP_LOCATION}/${merchant}`,
            addressCopy
        )
            .then((response) => {
                setFormLoading(false);
                handleClose();
                loadLocation(merchant);
            })
            .catch((err) => {
                console.error(err);
                setFormLoading(false);
                setHasLoadedOnce(false);
            });
    };

    const loadLocation = (id) => {
        setLoading(true);
        get(`${apiConstants.MERCHANT}/${id}`)
            .then((response) => {
                setLoading(false);
                if (response.data?.pickup_details && response.data?.pickup_details?.length > 0) {
                    const reverseLocationList = response.data.pickup_details.reverse();
                    // setLocation(filterByProp(reverseLocationList, "is_deleted"));
                    setLocation(reverseLocationList);
                } else {
                    setLocation([]);
                    setFilteredLocationList([]);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setLoading(false);
                setHasLoadedOnce(true);
            });
    };


    const toggleDefault = (id, is_default) => {
        setCurrentId(null);
        setLoading(true);
        const result = findInObjArr(locationList, id, "id");
        const addressCopy = Object.assign({}, result, {
            is_default: is_default === false ? true : false,
        });
        post(
            `${apiConstants.PICKUP_LOCATION}/${merchant}`,
            addressCopy
        )
            .then((response) => {
                setLoading(false);
                handleClose();
                loadLocation(merchant);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };

    const toggleStatus = (id, status) => {
        setCurrentId(null);
        setLoading(true);
        const result = findInObjArr(locationList, id, "id");
        const addressCopy = Object.assign({}, result, {
            status: status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
        });
        post(
            // `${apiConstants.BASE_LOCAL}${apiConstants.PICKUP_LOCATION}/${merchantId}`,
            `${apiConstants.PICKUP_LOCATION}/${merchant}`,
            addressCopy
        )
            .then((response) => {
                setLoading(false);
                handleClose();
                loadLocation(merchant);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };

    const handleEditClick = (id) => {
        const result = findInObjArr(locationList, id, "id");
        setCurrentId(result);
        handleShow();
    };

    const handleDownloadSampleClick = () => {
        setLoading(true);
        getDownload(
            `${apiConstants.BASE_LOCAL}${apiConstants.DOWNLOAD_SAMPLE_LOCATION}?fileName=MERCHANT_PICKUP`
        )
            .then((response) => {
                setLoading(false);
                const binaryData = [];
                binaryData.push(response.data);
                const href = URL.createObjectURL(
                    new Blob(binaryData, { type: "application/octet-stream" })
                );
                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "pickup-location.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };

    const handleBulkUpload = (e) => {
        const param = e.target.files[0];
        if (!param) return;
        
        const formData = new FormData();
        formData.append("file", param);
        formData.append("fileName", param.name);
        setLoading(true);
        postMultipart(`${apiConstants.UPLOAD_LOCATION}/${merchant}`, formData)
            .then((response) => {
                setLoading(false);
                setUploadResponse(response?.data);
                if (response?.data?.failedOrders?.length > 0) {
                    setFailedOrders(response.data.failedOrders);
                    setErrorDialogOpen(true);
                    enqueueSnackbar("Some orders failed to upload. Please check the details.", { variant: "warning" });
                    loadLocation(merchant);
                } else {
                    enqueueSnackbar("Successfully uploaded!", { variant: "success" });
                    loadLocation(merchant);
                }
                
                // Reset file input to allow uploading the same file again
                if (e.target) {
                    e.target.value = '';
                }
            })
            .catch((err) => {
                console.error(err);
                enqueueSnackbar("Could not be uploaded!", { variant: "error" });
                setLoading(false);
                // Reset file input even on error
                if (e.target) {
                    e.target.value = '';
                }
            });
    };
    const toggleDelete = (id, isDelete) => {
        setOpen(true)
        setCurrentId(id)
        setIsDelete(isDelete)
        // handleAgree(id, isDelete)
    };

    const handleCloseDelete = () => {
        setOpen(false)
        setCurrentId()
        setIsDelete()
    }

    const handleAgree = () => {
        const delted = isDelete === null || isDelete === "0" ? "1" : "0";
        setCurrentId(null);
        setLoading(true);
        const result = findInObjArr(locationList, currentId, "id");
        const addressCopy = Object.assign({}, result, { is_deleted: delted });
        post(
            // `${apiConstants.BASE_LOCAL}${apiConstants.PICKUP_LOCATION}/${merchantId}`,
            `${apiConstants.PICKUP_LOCATION}/${merchant}`,
            addressCopy
        )
            .then((response) => {
                setLoading(false);
                handleClose();
                handleCloseDelete()
                loadLocation(merchant);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
                handleCloseDelete()
            });
    }


    const handleAddClick = () => {
        setCurrentId(null);
        handleShow();
    };

    const handleFilter = (filterValues) => {
        const { contactNumber, name } = filterValues;
        const filteredLocations = locationList.filter((location) => {
            const matchesContactNumber = contactNumber
                ? location.contactNumber.includes(contactNumber)
                : true;
            const matchesName = name
                ? location.name.toLowerCase().includes(name.toLowerCase())
                : true;
            return matchesContactNumber && matchesName;
        });
        setFilteredLocationList(filteredLocations);
    };

    useEffect(() => {
        setFilteredLocationList(locationList);
    }, [locationList]);

    const resetFilter = () => {
        setFilteredLocationList(locationList);
    };

    const selectedMerchant = watch("merchant");

    useEffect(() => {
        if (selectedMerchant) {
            setHasLoadedOnce(false);
            loadLocation(selectedMerchant);
            setMerchant(selectedMerchant);
        }
    }, [selectedMerchant]);


    return (
        <>
            <PageTitle>Pickup Locations</PageTitle>
            {loading && <Loader />}
            <input
                type="file"
                onChange={handleBulkUpload}
                ref={bulkUploadRef}
                style={{ display: "none" }}
            />
            <Card>
                <CardContent>
                    <FormProvider methods={methods}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <MerchantFilterCached />
                            </Grid>
                            <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Button type="button" variant="contained" size="small" color="error" onClick={() => {
                                    reset({
                                        merchant: '',
                                    })
                                    setMerchant()
                                    setLocation([])
                                    setFilteredLocationList([])
                                    setHasLoadedOnce(false)
                                }}>Reset</Button>
                            </Grid>
                            {!merchant && (
                                <Grid item xs={12}>
                                    <Alert severity="info" sx={{ borderRadius: 1 }}>
                                        Please select a merchant to view their associated pickup locations.
                                    </Alert>
                                </Grid>
                            )}
                            {(merchant && filteredLocationList?.length === 0 && !loading && hasLoadedOnce) && (
                                <Grid item xs={12}>
                                    <Alert severity="error" sx={{ borderRadius: 1 }}>
                                        No pickup locations found for the selected merchant.
                                    </Alert>
                                </Grid>
                            )}
                        </Grid>
                    </FormProvider>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Box
                                sx={{
                                    justifyContent: "flex-end",
                                    width: 1,
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <ButtonGroup
                                    sx={{
                                        "& button": {
                                            borderRight: "0 !important",
                                            color: "inherit",
                                            textTransform: "capitalize",
                                        },
                                    }}
                                    variant="text"
                                >
                                    <Button
                                        startIcon={<AddCircleRounded color="primary" />}
                                        type="button"
                                        color="primary"
                                        onClick={handleAddClick}
                                    >
                                        Add
                                    </Button>
                                    <Button
                                        startIcon={<UploadFileRounded color="warning" />}
                                        type="button"
                                        color="warning"
                                        onClick={() => merchant ? bulkUploadRef.current.click() : enqueueSnackbar("Please select a Merchant before uploading.", { variant: "error" })}
                                    >
                                        Upload
                                    </Button>
                                    <Button
                                        startIcon={<DownloadRounded color="primary" />}
                                        type="button"
                                        color="warning"
                                        onClick={handleDownloadSampleClick}
                                    >
                                        Sample Download
                                    </Button>
                                </ButtonGroup>
                            </Box>
                        </Grid>
                    </Grid >
                </CardContent>
            </Card>
            {merchant &&
                <FilterLocation onFilter={handleFilter} resetFilter={resetFilter} />
            }

            <LocationDataGrid
                filteredLocationList={filteredLocationList}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                toggleDefault={toggleDefault}
                toggleStatus={toggleStatus}
                handleEditClick={handleEditClick}
                toggleDelete={toggleDelete}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />

            <Dialog
                open={open}
                onClose={handleCloseDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {""}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete Pickup Location ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDelete}>No</Button>
                    <Button onClick={handleAgree}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={errorDialogOpen}
                onClose={() => setErrorDialogOpen(false)}
                aria-labelledby="error-dialog-title"
                aria-describedby="error-dialog-description"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="error-dialog-title">
                    <Typography variant="h6" color="error">
                        Upload Issues Detected
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    {uploadResponse && (
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" color="text.secondary" gutterBottom>
                                <strong>Status:</strong> {uploadResponse.status}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" gutterBottom>
                                <strong>Total Orders:</strong> {uploadResponse.totalOrders} | 
                                <strong> Success:</strong> {uploadResponse.successOrders?.length || 0} | 
                                <strong> Failed:</strong> {uploadResponse.failedOrders?.length || 0}
                            </Typography>
                            {uploadResponse.fileName && (
                                <Typography variant="body2" color="text.secondary">
                                    <strong>File:</strong> {uploadResponse.fileName}
                                </Typography>
                            )}
                        </Box>
                    )}
                    {failedOrders.length > 0 && (
                        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><strong>Reference</strong></TableCell>
                                        <TableCell><strong>Reason</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {failedOrders.map((order, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell>{order.reference || 'N/A'}</TableCell>
                                            <TableCell>
                                                <Typography variant="body2" color="error">
                                                    {order.reason || 'Unknown error'}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setErrorDialogOpen(false)} variant="contained" color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <SideDrawer
                open={show}
                setOpen={handleClose}
                drawerWidth='70%'
                title={currentId ? "Edit Pickup Location" : "Add Pickup Location"}
                children={<AddLocation show={show}
                    formLoading={formLoading}
                    handleData={addPickupLocation}
                    currentId={currentId}
                    activeTab={activeTab}
                    existingLocationNames={existingLocationNames} />}
            />
        </>
    );
}

export default withLayout(() => {
    return (
        <div id="main-content" className="container-fluid">
            <MerchantLocations />
        </div>
    );
});


// ********below is previous view of the table********

// columns={[
//     { headerName: "Name", field: "name", flex: 1 },
//     {
//         headerName: "Address",
//         field: "pincode",
//         flex: 1,
//         renderCell: ({ row }) => {
//             const addArr = [];
//             if (row.address_line) addArr.push(row.address_line);
//             if (row.city) addArr.push(row.city);
//             if (row.state) addArr.push(row.state);
//             if (row.pincode) addArr.push(row.pincode);
//             if (row.country) addArr.push(row.country);
//             return addArr.join(", ");
//         },
//     },
//     { headerName: "Contact No", field: "contactNumber", flex: 1 },
//     { headerName: "Email", field: "email", flex: 1 },
//     { headerName: "GSTIN", field: "gstin", flex: 1 },
//     {
//         headerName: "Status",
//         field: "status",
//         flex: 1,
//         renderCell: ({ row }) => {
//             return (
//                 <Chip
//                     sx={{ fontWeight: 500 }}
//                     label={row.status}
//                     size="small"
//                     color={row.status === "ACTIVE" ? "success" : "error"}
//                 />
//             );
//         },
//     },
//     {
//         headerName: "Is Default",
//         field: "is_default",
//         flex: 1,
//         renderCell: ({ row }) => {
//             return (
//                 <>
//                     {row.is_default === true ? (
//                         <Tooltip title="Mark Undefault">
//                             <IconButton
//                                 onClick={() => toggleDefault(row.id, row.is_default)}
//                             >
//                                 <CheckCircleIcon color="success" />
//                             </IconButton>
//                         </Tooltip>
//                     ) :
//                         <Tooltip title="Mark Default">
//                             <IconButton
//                                 onClick={() => toggleDefault(row.id, row.is_default)}
//                             >
//                                 <CancelIcon color="error" />
//                             </IconButton>
//                         </Tooltip>
//                     }
//                 </>
//             );
//         },
//     },
//     {
//         headerName: "Action",
//         field: "action",
//         flex: 1,
//         renderCell: ({ row }) => {
//             return (
//                 <>
//                     {row.status === "ACTIVE" ? (
//                         <Tooltip title="Deactivate">
//                             <IconButton
//                                 onClick={() => toggleStatus(row.id, row.status)}
//                             >
//                                 <CheckCircleIcon color="success" />

//                             </IconButton>
//                         </Tooltip>
//                     ) :
//                         <Tooltip title="Activate">
//                             <IconButton
//                                 onClick={() => toggleStatus(row.id, row.status)}
//                             >
//                                 <CancelIcon color="error" />
//                             </IconButton>
//                         </Tooltip>
//                     }
//                     <Tooltip title="Edit Pickup Location">
//                         <IconButton onClick={() => handleEditClick(row.id)}>
//                             <img src="/img/edit.svg" width={18} alt="edit" />
//                         </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Delete Pickup Location">
//                         <IconButton
//                             onClick={() => toggleDelete(row.id, row.is_deleted)}
//                         >
//                             <img src="/img/remove.svg" width={18} alt="remove" />
//                         </IconButton>
//                     </Tooltip>
//                 </>
//             );
//         },
//     },
// ]}

